// Excel requires a UTF8_BOM to be added to the csv file for importing it with the correct encoding
const UTF8_BOM = '\uFEFF';

export default UTF8_BOM;
